import { ButtonsPaperProps } from './types';

import { ButtonsWrapper } from './styled';

export default function ButtonsPaper({ children }: ButtonsPaperProps) {
  return <ButtonsWrapper>{children}</ButtonsWrapper>;
}
